import { deviceSize, useDeviceSize } from 'fitify-ui'
import { ArrowRightIcon } from 'fitify-ui/src/Icon/outline'
import {
  MobileAnimation,
  MobileAppFeatures,
} from 'fitify-ui-landing/src/components/blocks'
import Header from 'fitify-ui-landing/src/components/blocks/Header/Header'
import Mentions from 'fitify-ui-landing/src/components/blocks/Mentions/Mentions'
import Button from 'fitify-ui-landing/src/components/Button/Button'
import { createRedirectLinkWithLocale } from 'fitify-ui-landing/src/utils/link'
import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import Apps from '@/components/blocks/Apps/Apps'
import { Reviews } from '@/components/blocks/Reviews/Reviews'
import Tools from '@/components/blocks/Tools/Tools'
import Layout from '@/components/layouts/Layout'
import { animationData } from '@/data/animations'
import { headerImages } from '@/data/header'
import { mentionsData } from '@/data/mentions'
import { getStaticPropsTranslations } from '@/utils/i18n'

const Home: NextPage = () => {
  const { t, i18n } = useTranslation()

  const { windowWidth } = useDeviceSize()
  const isPhoneBreakpoint = windowWidth <= deviceSize.phone

  return (
    <Layout>
      <Header
        headerImages={headerImages}
        headline={'landing_page_title'}
        subheadline={'landing_page_subheadline'}
        button={
          <Button
            icon={<ArrowRightIcon />}
            variant={'primary-blue'}
            href={createRedirectLinkWithLocale(
              process.env.NEXT_PUBLIC_ONBOARDING_URL,
              i18n.language
            )}
            target="_blank"
          >
            {t('landing_cta_button')}
          </Button>
        }
        shouldShowRating
      />

      {isPhoneBreakpoint ? (
        <MobileAppFeatures features={animationData} />
      ) : (
        <MobileAnimation features={animationData} />
      )}

      <Mentions mentionsItems={mentionsData} />

      <Reviews />

      <Tools />
      <Apps />
    </Layout>
  )
}

export default Home

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
